import {Pipe, PipeTransform} from '@angular/core';


interface TextTruncateOptions {
  sliceStart?: number;
  sliceEnd?: number;
  prepend?: string;
  append?: string;
  completeWords?: boolean;
}

@Pipe({
  name: 'truncateText'
})
export class TruncateTextPipe implements PipeTransform {

  transform(value: string, options: TextTruncateOptions = {
    sliceStart: 0,
    sliceEnd: 20,
    append: '...',
    completeWords: true,
  }): string {
    if (value && value.length >= options.sliceEnd) {

      // Truncate by chars
      let truncatedText = value.slice(options.sliceStart, options.sliceEnd);

      // Truncate by word
      if (options.completeWords) {
        const indexOfLastCompleteWordValue = truncatedText.lastIndexOf(' ');
        truncatedText = truncatedText.substring(0, indexOfLastCompleteWordValue);
      }

      truncatedText = this.prefixOrSuffixText(truncatedText, options);
      return truncatedText;
    }
    return value;
  }

  private prefixOrSuffixText(text, options: TextTruncateOptions) {
    if (options.prepend) {
      text = `${options.prepend}${text}`;
    }
    if (options.append) {
      text = `${text}${options.append}`;
    }
    return text;
  }
}
